import React, { Dispatch, SetStateAction } from 'react';

export interface FlightMasterInterface {
  showAllPoints?: boolean;
  setShowAllPoints?: Dispatch<SetStateAction<boolean>>;
}

export const FlightMasterContext = React.createContext<FlightMasterInterface | null>(null);
